var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-report',{attrs:{"title":"Relatórios"}}),_c('daily-amount'),_c('filter-report'),_c('chart-filter-container'),_c('open-dialog-export-report'),_c('open-dialog-request-report')],1)}
var staticRenderFns = []

export { render, staticRenderFns }